<script setup lang="ts">
import { brandConfig } from '~/config/brand'

defineProps<{
  collapsed?: boolean
}>()
</script>

<template>
  <NuxtLink
    to="/"
    class="flex items-center gap-2 py-2 pl-3 rounded-md transition-colors data-[state=open]:bg-elevated"
    :class="{ 'justify-center': collapsed }"
  >
    <img :src="'/logo.png'" :alt="brandConfig.app.name" class="h-8 shrink-0" />
    <span v-if="!collapsed" class="font-semibold text-sm sidebar-logo-text">
      {{ brandConfig.app.name }}
    </span>
  </NuxtLink>
</template>
